import {
  Placement,
  autoUpdate,
  flip,
  offset,
  shift,
  useDismiss,
  useFloating,
  useFocus,
  useInteractions,
} from '@floating-ui/react';
import { useDatePicker } from '@rehookify/datepicker';
import React from 'react';

export function useFloatingPicker(params: { placement: Placement }) {
  const [open, setOpen] = React.useState(false);

  const floatingProps = useFloating({
    open,
    onOpenChange: setOpen,
    middleware: [
      offset({
        mainAxis: 8,
        crossAxis: -16,
      }),
      shift({ padding: 16 }),
      flip({ fallbackAxisSideDirection: 'end' }),
      //   autoPlacement({ autoAlignment: true }),
    ],
    whileElementsMounted: autoUpdate,
    placement: params.placement,
    strategy: 'absolute',
  });
  //   const click = useClick(floatingProps.context);
  const dismiss = useDismiss(floatingProps.context);
  const focus = useFocus(floatingProps.context);

  const interactionProps = useInteractions([dismiss, focus]);

  return {
    open,
    setOpen,
    floatingProps,
    interactionProps,
  };
}

export function useDatePickerCalendar(params: {
  onChange?: (dates: Date[]) => void;
  value?: Date[];
  minDate?: Date | undefined;
  maxDate?: Date | undefined;
  locale: string;
}) {
  const { onChange, value, minDate, maxDate, locale } = params;

  return useDatePicker({
    onDatesChange: onChange,
    selectedDates: value,
    years: { step: 10 },
    dates: {
      mode: 'single',
      toggle: false,
      minDate,
      maxDate,
    },
    calendar: {
      offsets: [0],
      mode: 'static',
      // @ts-expect-error number from env
      startDay: Number(process.env.REACT_APP_WEEK_STARTS_ON ?? 1),
    },
    locale: {
      locale,
    },
  });
}
